export default __webpack_public_path__ + "static/media/intro-image.0ccd9a31.jpg";